import { useSessionStore } from "~/stores/session";

export default defineNuxtRouteMiddleware(async () => {
  const session = useSessionStore();
  await session.restoreSession();

  if (!session.isAuthenticated) return navigateTo("/auth/login");
  if (session.isAdmin) return navigateTo("/admin/company");
  if (!session.isParticipant) return navigateTo("/auth/login");

  // Guard: participant must have contact data
  if (!session.user?.email && !session.user?.phone) {
    return navigateTo("/auth/complete-contact");
  }
});
